import productFilterGroups from './product-filter-groups';
import inputFile from './input-file';

export function exec () {
    productFilterGroups();
	inputFile();
}



// WEBPACK FOOTER //
// ./client/src/core/components/forms/index.js